import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";

const GrnRejectionModal = ({ showModal, closeModal, branch, onSelectItem }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [allSuppliers, setAllSuppliers] = useState([]); 
  const [filteredSuppliers, setFilteredSuppliers] = useState([]); 
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (showModal) {
      fetchSuppliers();
    }
  }, [showModal]);

  const fetchSuppliers = async () => {
    setLoading(true);
    try {
      const response = await axios.get("https://rfs2.infraconsoft.net.in/api/grnRejection_modal", {
        params: { branchcode: branch },
      });
      setAllSuppliers(response.data);
      setFilteredSuppliers(response.data); 
    } catch (error) {
      console.error("Error fetching suppliers:", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (!searchTerm.trim()) {
      setFilteredSuppliers(allSuppliers);
    } else {
      const filtered = allSuppliers.filter(
        (item) =>
          item.prdetail_suppliercode.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.suppliermaster_Name.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredSuppliers(filtered);
    }
  }, [searchTerm, allSuppliers]);

  const handleSelectItem = (item) => {
    onSelectItem(item);
    closeModal();
  };

  if (!showModal) return null;

  return (
    <div className="modal">
      <div className="modal-content">
        <h3 className="modal-title">Select Supplier</h3>

        <div className="search-filter">
          <p>Search Supplier:</p>
          <input
            type="text"
            className="search-input"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Type to search..."
          />
        </div>

        <div className="search-results">
          <table>
            <thead>
              <tr>
                <th>GRN No</th>
                <th>Date</th>
                <th>Supplier Code</th>
                <th>Supplier Name</th>
                <th>Select</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="5" className="loading-text">Loading...</td>
                </tr>
              ) : filteredSuppliers.length > 0 ? (
                filteredSuppliers.map((item) => (
                  <tr key={item.grnheader_suppliercode}>
                    <td>{item.headernumber}</td>
                    <td>{new Date(item.grnHeader_date).toLocaleDateString("en-GB")}</td>
                    <td>{item.grnheader_suppliercode}</td>
                    <td>{item.supplierMaster_name}</td>
                    <td>
                      <button className="select-btn" onClick={() => handleSelectItem(item)}>Select</button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5">No results found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <button className="close-btn" onClick={closeModal}>Close</button>
      </div>
    </div>
  );
};

export default GrnRejectionModal;
